import React, { useRef, useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import axios from "axios";
import * as XLSX from "xlsx-js-style";
import { BASE_URL } from "../Apis/apiConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Download, Upload, FileSpreadsheet, Eye, Edit, Trash2, AlertCircle, CheckCircle, X, ArrowLeft, Database, Cloud, FileCheck, RefreshCw, Plus, ChevronRight, Users,
  FileText, Folder, MinusCircle, PlusCircle, Receipt, Car, Wallet } from "lucide-react";
  import { FaWhatsapp } from "react-icons/fa";
import { fetchBillHeaders } from "../Apis/BillHeader";
import { useNavigate } from "react-router-dom";
import '../Style/UploadMenu.css'

const UPLOAD_TYPES = [
  { key: "member", label: "MEMBER LIST", tableSuffix: "_member", templateName: "member", icon: Users, color: "#3b82f6" },
  { key: "bill", label: "BILL", tableSuffix: "_bill", templateName: "bill", icon: FileText, color: "#060808" },
  { key: "opening", label: "OPENING", tableSuffix: "_opening", templateName: "opening", icon: Folder, color: "#8b5cf6" },
  { key: "debit", label: "DEBIT NOTE", tableSuffix: "_Debit Note", templateName: "debit", icon: MinusCircle, color: "#f97316" },
  { key: "credit", label: "CREDIT NOTE", tableSuffix: "_Credit Note", templateName: "credit", icon: PlusCircle, color: "#06b6d4" },
  { key: "receipt", label: "RECEIPT", tableSuffix: "_Receipt", templateName: "receipt", icon: Receipt, color: "#6366f1" },
  { key: "parking", label: "PARKING", tableSuffix: "_Parking", templateName: "parking", icon: Car, color: "#14b8a6" },
  { key: "advancepayment", label: "ADVANCE PAYMENT", tableSuffix: "_ADVANCE PAYMENT", templateName: "advancepayment", icon: Wallet, color: "#ef4444" }
];
const UploadMenu = () => {
  const refs = {
    member: useRef(),
    bill: useRef(),
    opening: useRef(),
    debit: useRef(),
    credit: useRef(),
    receipt: useRef(),
    parking: useRef(),
    advancepayment: useRef(),
    ledger: useRef(),
  };
  const navigate = useNavigate();
  const society = localStorage.getItem("society") || "society";
  const [previews, setPreviews] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalRows, setModalRows] = useState([]);
  const [modalHeaders, setModalHeaders] = useState([]);
  const [modalTypeKey, setModalTypeKey] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [Billheaders, setBillHeaders] = useState([]);
  const [isBillTableCreated, setIsBillTableCreated] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [modalPdf, setModalPdf] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [ledgerExcel, setLedgerExcel] = useState(null);
  const [ledgerPdfs, setLedgerPdfs] = useState({});
  const [saveProgress, setSaveProgress] = useState(0);
  const [sendWhatsapp, setSendWhatsapp] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const isValidEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  };
  const sanitizeEmail = (value) => {
    return value.replace(/\s/g, "").toLowerCase();
  };
  const normalizeUnitNo = (value) => {
    if (!value) return "";
    let v = String(value).toUpperCase().replace(/\s+/g, "");
    const match = v.match(/^([A-Z]+)-?(\d+)$/);
    return match ? `${match[1]}-${match[2]}` : v;
  };
  const onlyLetters = (value) => {
    return value.replace(/[^a-zA-Z\s]/g, "");
  };
  const onlyNumber = (value) => {
    if (value === null || value === undefined) return "";
    return String(value).replace(/[^0-9.]/g, "");
  };
  const normalizeDate = (value) => {
    let v = value.replace(/[^0-9]/g, "");
    if (v.length > 8) v = v.slice(0, 8);

    if (v.length >= 5)
      return `${v.slice(0, 2)}-${v.slice(2, 4)}-${v.slice(4)}`;
    if (v.length >= 3)
      return `${v.slice(0, 2)}-${v.slice(2)}`;
    return v;
  };

  const handleLedgerPdfSelect = (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const newLedgerPdfs = { ...ledgerPdfs };
    for (const file of files) {
      newLedgerPdfs[file.name] = file;
    }
    setLedgerPdfs(newLedgerPdfs);
    setModalRows((rows) =>
      rows.map((r) => {
        const pdfKey = Object.keys(newLedgerPdfs).find(
          (name) => !rows.some((row) => row["Ledger PDF"] === name)
        );
        if (pdfKey) r["Ledger PDF"] = pdfKey;
        return r;
      })
    );

    toast.success(`${files.length} PDF(s) attached to Ledger`, {
      position: "bottom-right",
    });
  };
  const uploadToServer = async (file, tableName, isEdit = false, pdfs = null) => {
    setIsUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tableName", tableName);
    formData.append("sendWhatsapp",tableName.includes("_bill") ? sendWhatsapp : false);
    if (isEdit) formData.append("isEdit", true);
    if (pdfs && Array.isArray(pdfs)) {
      pdfs.forEach((pdf) => {
        formData.append("ledgerPdfs", pdf);
      });
    }
    const token = localStorage.getItem("token");

    try {
      const res = await axios.post(
        `${BASE_URL}/api/member/upload-excel`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          }
        }
      );

      if (res.status === 200) {
        toast.warn(res.data || "Excel uploaded successfully", {
          position: "bottom-right",
          autoClose: 3000,
        });

        return res.data;

      } else {
        toast.error("Excel not uploaded. Columns do not match template.", {
          position: "bottom-right",
          autoClose: 4000,
        });
      }
      const respText =
        typeof res.data === "string" ? res.data : JSON.stringify(res.data);

      if (respText && /duplicate/i.test(respText)) {
        toast.warning(respText, { position: "bottom-right", autoClose: 4000 });
      } else {
        toast.success(
          respText ||
          (isEdit ? "Excel Not Uploaded" : "Excel Not Uploaed"),
          { position: "bottom-right", autoClose: 3000 }
        );
      }

      return res.data;
    } catch (err) {
      console.error("Upload failed:", err);
      const msg = err.response?.data || err.message || "Upload failed";
      const errText = typeof msg === "string" ? msg : JSON.stringify(msg);
      toast.error("Excel not uploaded. Columns do not match template.", {
        position: "bottom-right",
        autoClose: 4000,
      });
      throw err;
    } finally {
      setIsUploading(false);
    }
  };
  const parseFileForPreview = async (file) => {
    try {
      const ab = await file.arrayBuffer();
      const wb = XLSX.read(ab, {
        type: "array",
        cellStyles: true,
        cellNF: true,
      });
      const sheetName = wb.SheetNames[0];
      const ws = wb.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(ws, {
        defval: "",
        raw: true,
      });

      return { sheetName, rows };
    } catch (err) {
      console.error("Error parsing file:", err);
      return null;
    }
  };

  const isValidDDMMYYYY = (value) => {
    if (!value) return true;
    const match = String(value).match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (!match) return false;
    const [, d, m, y] = match;
    const date = new Date(`${y}-${m}-${d}`);
    return (
      date.getFullYear() === parseInt(y) &&
      date.getMonth() + 1 === parseInt(m) &&
      date.getDate() === parseInt(d)
    );
  };

  const excelDateToDDMMYYYY = (value) => {

    if (typeof value === "number") {
      const utcDays = Math.floor(value - 25569);
      const date = new Date(utcDays * 86400 * 1000);

      const d = String(date.getUTCDate()).padStart(2, "0");
      const m = String(date.getUTCMonth() + 1).padStart(2, "0");
      const y = date.getUTCFullYear();

      return `${d}-${m}-${y}`;
    }

    if (typeof value === "string") {
      const match = value.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2}|\d{4})$/);
      if (!match) return value;

      let [, d, m, y] = match;
      d = d.padStart(2, "0");
      m = m.padStart(2, "0");
      y = y.length === 2 ? `20${y}` : y;

      return `${d}-${m}-${y}`;
    }
    return value;
  };

  const rowsToExcelFile = (rows, filename = "updated.xlsx") => {
    const ws = XLSX.utils.json_to_sheet(rows, { skipHeader: false });
    const headers = rows && rows.length > 0 ? Object.keys(rows[0]) : [];
    if (headers && headers.length) {
      ws["!cols"] = headers.map((h) => ({
        wch: Math.max(12, Math.min(40, h.length + 6)),
      }));
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const arrayBuf = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    const blob = new Blob([arrayBuf], { type: "application/octet-stream" });
    try {
      return new File([blob], filename, {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    } catch {
      return blob;
    }
  };

  const handleSelectFile = async (e, type) => {
    const files = e?.target?.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    const allowedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // .xlsx
    ];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only Excel files (.xls or .xlsx) are allowed", {
        position: "bottom-right",
      });
      if (refs[type.key] && refs[type.key].current)
        refs[type.key].current.value = null;
      return;
    }

    const parsed = await parseFileForPreview(file);
    if (!parsed) {
      toast.error("Could not parse file for preview", {
        position: "bottom-right",
      });
      if (refs[type.key] && refs[type.key].current)
        refs[type.key].current.value = null;
      return;
    }
    setPreviews((p) => ({
      ...p,
      [type.key]: {
        fileName: file.name,
        sheetName: parsed.sheetName,
        rows: parsed.rows,
      },
    }));

    setTimeout(() => {
      openModalForType(
        type.key,
        parsed.rows,
        `${type.label} — ${file.name}`
      );
    }, 100);

    if (refs[type.key] && refs[type.key].current)
      refs[type.key].current.value = null;
  };

  const openModalForType = (typeKey, rows, title, isPdf = false) => {
    const headers = rows && rows.length > 0 ? Object.keys(rows[0]) : [];

    const fixedRows = (rows || []).map((r) => {
      const copy = { ...r };
      Object.keys(copy).forEach((k) => {
        if (k.toLowerCase().includes("date")) {
          copy[k] = excelDateToDDMMYYYY(copy[k]);
        }
      });
      return copy;
    });

    setModalRows(fixedRows);
    setModalHeaders(headers);
    setModalTitle(title || "Preview");
    setModalTypeKey(typeKey);
    setModalOpen(true);
    setModalPdf(isPdf);
  };

  const openModalFromPreview = (typeKey) => {
    const pr = previews[typeKey];
    if (!pr || !pr.rows) {
      toast.info("No preview available", { position: "bottom-right" });
      return;
    }
    openModalForType(
      typeKey,
      pr.rows,
      `${UPLOAD_TYPES.find((t) => t.key === typeKey)?.label || ""} — ${pr.fileName || ""}`,
    );
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalRows([]);
    setModalHeaders([]);
    setModalTitle("");
    setModalTypeKey(null);
  };

  const handleDeletePreview = async (key) => {
    if (!previews[key]) {
      toast.info("No uploaded file to remove", {
        position: "bottom-right",
        autoClose: 1500,
      });
      return;
    }
    if (
      !window.confirm(
        "Remove uploaded file preview (this does not delete server data unless supported)?",
      )
    )
      return;
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${BASE_URL}/api/member/delete-table`,
        {
          tableName: `${society}${UPLOAD_TYPES.find((t) => t.key === key).tableSuffix}`,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toast.success("Server data cleared for this table (if supported)", {
        position: "bottom-right",
      });
    } catch (err) {
      console.warn(
        "Server delete failed or endpoint not present:",
        err?.message || err,
      );
    }
    setPreviews((p) => {
      const n = { ...p };
      delete n[key];
      return n;
    });
    toast.info("Preview removed", {
      position: "bottom-right",
      autoClose: 1500,
    });
    if (modalTypeKey === key) closeModal();
  };

  const handleCellChange = (rowIndex, header, value) => {
    setModalRows((rows) => {
      const copy = rows.map((r) => ({ ...r }));
      let updatedValue = value;
      const h = header.toLowerCase();
      if (h.includes("unit_no")) {
        updatedValue = normalizeUnitNo(value);
      }
      else if (h.includes("member_name") && !h.includes("email")) {
        updatedValue = onlyLetters(value);
      }
      else if (h.includes("date")) {
        updatedValue = normalizeDate(value);

        if (updatedValue.length === 10 && !isValidDDMMYYYY(updatedValue)) {
          toast.warning(`Date must be DD-MM-YYYY format. Example: 10-02-2026`, {
            position: "bottom-right",
            autoClose: 2500,
            toastId: "date-format-warn", 
          });
        }
      }
      else if (h.includes("email")) {
        updatedValue = sanitizeEmail(value);
        if (updatedValue && !isValidEmail(updatedValue)) {
          toast.error("Invalid Email Format", {
            position: "bottom-right",
            autoClose: 1500,
          });
        }
      }

      else if (
        h.includes("amount") ||
        h.includes("total") ||
        h.includes("charges") ||
        h.includes("fee")
      ) {
        updatedValue = onlyNumber(value);
      }

      copy[rowIndex] = {
        ...copy[rowIndex],
        [header]: updatedValue,
      };

      return copy;
    });
  };


  const handleDeleteRow = (rowIndex) => {
    if (!window.confirm("Delete this row from the preview?")) return;
    setModalRows((rows) => {
      const copy = rows.slice();
      copy.splice(rowIndex, 1);
      return copy;
    });
  };

  const handleAddRow = () => {
    const newRow = {};
    modalHeaders.forEach((h) => (newRow[h] = ""));
    setModalRows((rows) => [newRow, ...rows]);
  };


  const handleSaveEdits = async () => {
    if (!modalTypeKey) return;
    if (!window.confirm("Do you want to save the changes to Excel?")) return;
    let progressInterval = setInterval(() => {
      setSaveProgress((prev) => {
        if (prev >= 90) {
          clearInterval(progressInterval);
          return prev;
        }
        return prev + 10;
      });
    }, 300);

    setIsSaving(true);
    setSaveProgress(10);
    try {
      const pr = previews[modalTypeKey];
      const filename = pr?.fileName
        ? `edited_${pr.fileName}`
        : `edited_${modalTypeKey}.xlsx`;

      const tableName = `${society}${UPLOAD_TYPES.find((t) => t.key === modalTypeKey).tableSuffix
        }`;

      for (const row of modalRows) {
        for (const key of Object.keys(row)) {
          const h = key.toLowerCase();
          if (h.includes("date") && row[key]) {
            if (!isValidDDMMYYYY(row[key])) {
              toast.error(
                `Invalid date format in column "${key}": "${row[key]}" — Please use DD-MM-YYYY format (e.g. 10-02-2026)`,
                { position: "bottom-right", autoClose: 5000 }
              );
              setIsSaving(false);
              return;
            }
          }
        }
      }
      const cleanedRows = modalRows.map((row) => {
        const r = { ...row };
        Object.keys(r).forEach((key) => {
          const h = key.toLowerCase();
          if (h.includes("unit")) r[key] = normalizeUnitNo(r[key]);
          else if (h.includes("member") && !h.includes("email"))
            r[key] = onlyLetters(r[key]);
          else if (h.includes("date")) r[key] = excelDateToDDMMYYYY(r[key]);
          else if (
            h.includes("amount") ||
            h.includes("total") ||
            h.includes("charges") ||
            h.includes("fee")
          ) {
            r[key] = onlyNumber(r[key]);
          }

          if (modalTypeKey === "ledger" && key === "Ledger PDF") {
            r[key] = r[key] || "";
          }

        });
        return r;
      });

      let fileOrBlob = rowsToExcelFile(cleanedRows, filename);
      if (fileOrBlob instanceof Blob && !(fileOrBlob instanceof File)) {
        fileOrBlob = new File([fileOrBlob], filename, {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      }

      let pdfFiles = null;
      if (modalTypeKey === "ledger" && ledgerPdfs) {
        pdfFiles = Object.values(ledgerPdfs);
      }

      await uploadToServer(fileOrBlob, tableName, true, pdfFiles);

      setPreviews((p) => ({
        ...p,
        [modalTypeKey]: {
          ...(p[modalTypeKey] || {}),
          rows: cleanedRows,
          fileName: filename,
        },
      }));

      toast.success("Changes saved successfully!", {
        position: "bottom-right",
        autoClose: 2000,
      });
      setSaveProgress(100);

      closeModal();
    } catch (err) {
      console.error("Error saving edits:", err);
      toast.error("Failed to save changes", {
        position: "bottom-right",
        autoClose: 2000,
      });
    } finally {
      clearInterval(progressInterval);
      setSaveProgress(0);
      setIsSaving(false);
    }
  };

  const isValidPhoneNumber = (value) => {
    const cleaned = String(value).replace(/\D/g, "");
    return cleaned.length === 10;
  };
  const downloadTemplate = async (name) => {
    const key = ("" + name).toLowerCase().replace(/[\s_]+/g, "");
    let headers = [];
    let headersToUse = [];

    if (key.includes("member")) {
      headers = [
        "Sr No", "Member Name", "Wing", "Unit No", "Phone Number", "Phone Number 1", "Phone Number 2", "Email", "Flat Square Feet", "Address", "Pincode", "Status", "Access Society",];
    } else if (key.includes("bill")) {
      let headersFromServer =
        Array.isArray(Billheaders) && Billheaders.length ? Billheaders : null;
      if (!headersFromServer) {
        const fetched = await fetchBillHeaders();
        console.log("api data is coming" + JSON.stringify(fetched));
        if (!fetched || fetched.length === 0) {
          setIsBillTableCreated(true);
          return;
        }
        setIsBillTableCreated(false);

        headersFromServer = fetched;
      }
      headersToUse = [
        ...headersFromServer.map((h) =>
          h == null ? "" : String(h).trim().toUpperCase(),
        ),
      ];

      if (!headersToUse || headersToUse.length === 0) {
        toast.error("Bill headers are empty — cannot create template.");
        return;
      } else if (key.includes("bill")) {
        let headersFromServer =
          Array.isArray(Billheaders) && Billheaders.length ? Billheaders : null;

        if (!headersFromServer) {
          const fetched = await fetchBillHeaders();
          console.log("api data is coming", fetched);

          if (!fetched || fetched.length === 0) {
            setIsBillTableCreated(true);
            return;
          }

          setIsBillTableCreated(false);
          headersFromServer = fetched;
        }

        const HIDDEN_HEADERS = ["ENABLED", "ENABLED_DATE"];
        headersToUse = headersFromServer
          .filter((h) => h)
          .map((h) => String(h).trim().toUpperCase())
          .filter((h) => !HIDDEN_HEADERS.includes(h));

        if (!headersToUse || headersToUse.length === 0) {
          toast.error("Bill headers are empty — cannot create template.");
          return;
        }
      }
    } else if (key.includes("credit")) {
      headers = ["Voucher No", "Unit No", "Member Name", "Credit Date"];
    } else if (key.includes("debit")) {
      headers = ["Voucher No", "Unit No", "Member Name",  "Debit Date"];
    } else if (key.includes("receipt")) {
      headers = ["Receipt No", "Unit No", "Receipt Date", "Member Name", "Instrument No", "Instrument", "Total Amount"];
    } else if (key.includes("opening")) {
      headers = ["Sr", "Member Name", "Total", "Unit No", "Wing", "Opening Date"];
    } else if (key.includes("parking")) {
      headers = ["Sr", "Member Name", "Unit No", "Number Plate", "Vehicle", "Phone Number", "Space No", "Parking Date"];
    } else if (key.includes("advancepayment") || key.includes("advance")) {
      headers = ["advance id", "Wing", "Unit No", "Advance payment Date", "Member Name", "Amount"];
    } else if (key.includes("ledger")) {
      headers = ["Sr No", "Member Name", "Unit No", "Visible", "Ledger PDF"];
    }
    else {
      headers = ["col 1", "col 2"]
    }

    if (!headersToUse || headersToUse.length === 0) {
      headersToUse = (headers || []).map((h) =>
        h == null ? "" : String(h).trim(),
      );
    }

    const aoa = [headersToUse];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    const headerStyle = {
      font: { name: "Calibri", sz: 12, bold: true, color: { rgb: "FFFFFFFF" } },
      fill: { fgColor: { rgb: "4472C4" } },
      alignment: { horizontal: "center", vertical: "center" },
    };
    for (let c = 0; c < headersToUse.length; c++) {
      const cell = XLSX.utils.encode_cell({ c, r: 0 });
      if (!ws[cell]) ws[cell] = { t: "s", v: headersToUse[c] };
      ws[cell].s = headerStyle;
    }
    ws["!cols"] = headersToUse.map((h) => ({
      wch: Math.max(12, Math.min(40, h.length + 6)),
    }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");

    const safeName = ("" + name)
      .replace(/[()]/g, "")
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_-]/gi, "")
      .replace(/_+/g, "_");
    try {
      XLSX.writeFile(wb, `${safeName}_template.xlsx`, {
        bookType: "xlsx",
        cellStyles: true,
      });
    } catch {
      XLSX.writeFile(wb, `${safeName}_template.xlsx`);
    }
  };

  const triggerPicker = (key) => {
    if (refs[key] && refs[key].current) refs[key].current.click();
  };

  useEffect(() => {
    const fetchHeaders = async () => {
      try {
        const fetched = await fetchBillHeaders();
        console.log("API data fetched for bill headers:", fetched);

        if (!fetched || fetched.length === 0) {
          setIsBillTableCreated(false);
        } else {
          setBillHeaders(fetched);
          setIsBillTableCreated(true);
        }
      } catch (err) {
        console.error("Error fetching bill headers:", err);
        setIsBillTableCreated(false);
        toast.error("Failed to fetch bill headers");
      }
    };

    fetchHeaders();
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && modalOpen) closeModal();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [modalOpen]);


  useEffect(() => {
    const societyName = localStorage.getItem("society");
    const typeExcelUpload = ["bill", "member", "credit", "debit_note", "credit_note", "receipt", "opening", "parking", "advance_payment"];

    const token = localStorage.getItem("token");

    axios.post(
      `${BASE_URL}/api/member/get-excel-uplaoded`,
      null,
      {
        params: {
          societyName: societyName,
          typeExcelUpload: typeExcelUpload,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => {
        console.log("Uploaded modules:", res.data);

        const uploadedData = res.data; 
   
        setPreviews((prev) => {
          const updated = { ...prev };

          Object.keys(uploadedData).forEach((type) => {
  let normalizedKey = type;

  if (type === "credit_note") normalizedKey = "credit";
  if (type === "debit_note") normalizedKey = "debit";
    if (type === "advance_payment") normalizedKey = "advancepayment";

  updated[normalizedKey] = {
    ...(prev[normalizedKey] || {}),
    uploaded: true,
    count: uploadedData[type],
  };
});

          return updated;
          console.log("api call here " + JSON.stringify(updated))
        });
      })
      .catch((err) => {
        console.error("Auth API Error:", err);
      });

  }, []);

  // const getLastDate = (countStr) => {
  //   if (!countStr) return "";

  //   const match = countStr.match(/Last\s*:\s*([0-9-]+)/i);
  //   console.log("api call here " + JSON.stringify(match))
  //   return match ? match[1] : "";
  // };

  const getLastDate = (countStr) => {
  if (!countStr) return "";

  // Handle: Count: 1 | Last: 18-06-2026
  let match = countStr.match(/Last\s*:\s*([0-9-]+)/i);
  if (match) {
    return match[1];
  }

  // Handle: Count: 1 | Dates: [18-06-2026]
  match = countStr.match(/Dates\s*:\s*\[?([0-9-]+)/i);
  if (match) {
    return match[1];
  }

  return "";
};

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />
      <div className="main-layout">
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
        <main className="content-area">
          <SubHeader />
          <div className="upload-tips">
            <div className="upload-tips-list">
              <div className="upload-tip">
                <div className="upload-tip-number">1</div>
                <div className="upload-tip-text">
                  Download the template first to ensure proper formatting
                </div>
              </div>
              <div className="upload-tip">
                <div className="upload-tip-number">2</div>
                <div className="upload-tip-text">
                  Fill in your data following the template structure
                </div>
              </div>
              <div className="upload-tip">
                <div className="upload-tip-number">3</div>
                <div className="upload-tip-text">
                  Preview your data before final submission
                </div>
              </div>
              <div className="upload-tip">
                <div className="upload-tip-number">4</div>
                <div className="upload-tip-text">
                  Save time by editing directly in the preview table
                </div>
              </div>
            </div>
          </div>

          <div className=" grid grid-cols-1 p-4 ">
            <div className="upload-cards-grid">
              {UPLOAD_TYPES.map((t) => {
                const pr = previews[t.key];
                const isBill = t.key === "bill";

                return (
                  <div className="upload-card-modern" key={t.key}>
                    <div className="upload-card-header">
                      <div className="upload-card-icon" style={{
                        background: `linear-gradient(135deg, ${t.color}20 0%, ${t.color}40 100%)`,
                        color: t.color,
                      }} >
                        {(() => {
                          const Icon = t.icon;
                          return <Icon size={24} />;
                        })()}
                      </div>
                      <h3 className="upload-card-title" style={{
                        background: "linear-gradient(90deg,#2563eb,#3b82f6)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontSize: 12
                      }}>{t.label}</h3>
                      {t.key === "bill" && (
  <button
    onClick={() => setSendWhatsapp(!sendWhatsapp)}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      border: "none",
      background: "transparent",
      cursor: "pointer",
      marginTop: "8px",
      padding: 0,
    }}
  >
    <FaWhatsapp
      size={40}
      color="#25D366"
    />

    <small
      style={{
        color: sendWhatsapp ? "#25D366" : "#64748b",
        fontSize: "11px",
        fontWeight: sendWhatsapp ? "600" : "400",
      }}
    >
      {sendWhatsapp
        ? "WhatsApp Bill Sharing Enabled"
        : "Click here to share bills with residents"}
    </small>
  </button>
)}
                    </div>

                    <div className="upload-card-actions">
                      {isBill ? (
                        !isBillTableCreated ? (
                          <button
                            className="upload-action-btn"
                            onClick={() => navigate("/dynamic-form")}
                            style={{ color: "black" }}
                          >
                            <Plus size={16} />
                            Table
                          </button>
                        ) : (
                          <button
                            className="upload-action-btn "
                            onClick={async () => {
                              try {
                                let headersFromServer =
                                  Array.isArray(Billheaders) && Billheaders.length
                                    ? Billheaders
                                    : null;
                                if (!headersFromServer) {
                                  const fetched = await fetchBillHeaders();
                                  if (!fetched || fetched.length === 0) {
                                    setIsBillTableCreated(false);
                                    toast.error(
                                      "Create Bill Table — Click Create Bill button"
                                    );
                                    return;
                                  }
                                  headersFromServer = fetched;
                                }
                                await downloadTemplate(
                                  (society || "society") + t.tableSuffix
                                );
                              } catch (err) {
                                toast.error(
                                  "Could not download template: " + (err.message || err)
                                );
                              }
                            }}
                          >
                            <Download size={16} />
                            Template
                          </button>
                        )
                      ) : (
                        <button
                          className="upload-action-btn"
                          onClick={() =>
                            downloadTemplate((society || "society") + t.tableSuffix)
                          }
                        >
                          <Download size={16} />
                          Template
                        </button>
                      )}
                      <div className="upload-wrapper">
                        <input
                          type="file"
                          ref={refs[t.key]}
                          style={{ display: "none" }}
                          accept={t.key === "ledger" ? ".pdf" : ".xls,.xlsx"}
                          onChange={(e) => handleSelectFile(e, t)}
                        />
                        <button
                          className="upload-action-btn primary"
                          onClick={() => triggerPicker(t.key)}
                        >
                          <Upload size={16} />
                          Upload
                        </button>
                      </div>
                    </div>
                    {pr ? (
                      <div className="upload-file-status success">
                        <div className="upload-file-info">
                          <span
                            style={{
                              flex: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={pr.fileName}
                          >
                            {pr.fileName}
                          </span>
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              whiteSpace: "nowrap",
                              padding: "4px 10px",
                              borderRadius: "20px",
                              background: "#ecfdf5",
                              color: "#059669",
                              fontSize: "13px",
                              fontWeight: 600,
                              border: "1px solid #a7f3d0"
                            }}
                          >
                            {getLastDate(pr?.count)} File Uploaded
                          </span>

                        </div>
                      </div>
                    ) :
                      (
                        <div
                          className="upload-file-status empty"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            padding: "4px 10px",
                            borderRadius: "18px",
                            background: "#f8fafc",
                            color: "#64748b",
                            fontSize: "13px",
                            fontWeight: 500,
                            border: "1px solid #e2e8f0",
                            whiteSpace: "nowrap"
                          }}
                        >
                          <AlertCircle size={14} />
                          <span>No file uploaded</span>
                        </div>
                      )}
                  </div>
                );
              })}
            </div>
          </div>
          {modalOpen && (
            <div className="upload-modal-overlay" onClick={closeModal}>
              <div
                className="upload-modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="upload-modal-header">
                  <h3 className="upload-modal-title">{modalTitle}</h3>
                  <div className="upload-modal-actions">
                    <button className="upload-action-btn" onClick={closeModal}>
                      Cancel
                    </button>
                    {/* <button
                      className="upload-action-btn primary"
                      onClick={handleSaveEdits}
                      disabled={isSaving}
                      style={{
                        opacity: isSaving || modalPdf ? 0.7 : 1,
                        cursor: isSaving || modalPdf ? "not-allowed" : "pointer",
                      }}
                    >
                      {isSaving ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <RefreshCw size={16} className="spin-animation" />
                          Saving...
                        </div>
                      ) : (
                        "Save Changes"
                      )}
                    </button> */}
                    <button
                      className="upload-action-btn"
                      onClick={() => handleDeletePreview(modalTypeKey)}
                      style={{
                        background: "#fee2e2",
                        border: "1px solid #fecaca",
                        color: "#dc2626",
                      }}> Delete</button>
                    {isSaving && (
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: "60%",
                          background: "#ffffff",
                          padding: "25px 30px",
                          borderRadius: "16px",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                          textAlign: "center",
                          zIndex: 200000
                        }}
                      >
                        <div
                          style={{
                            fontSize: "15px",
                            fontWeight: 600,
                            marginBottom: "15px",
                            color: "#059669"
                          }}
                        >
                          Processing Save... {saveProgress}%
                        </div>

                        <div
                          style={{
                            width: "100%",
                            height: "12px",
                            background: "#e5e7eb",
                            borderRadius: "10px",
                            overflow: "hidden"
                          }}
                        >
                          <div
                            style={{
                              width: `${saveProgress}%`,
                              height: "100%",
                              background: "linear-gradient(90deg,#22c55e,#16a34a)",
                              transition: "width 0.3s ease"
                            }}
                          />
                        </div>
                      </div>
                    )}

                  </div>
                </div>
                <div className="upload-modal-body">
                  <div
                    style={{
                      padding: "20px",
                      background: "#f8fafc",
                      borderRadius: "12px",
                      marginBottom: "20px",
                    }}
                  >
                    <p
                      style={{ margin: 0, color: "#64748b", fontSize: "14px" }}
                    >
                      Edit cells directly in the table. Changes will be saved
                      when you click "Save Changes".
                    </p>
                  </div>

                  <div
                    style={{
                      background: "white",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      overflow: "auto",
                      maxHeight: "400px",
                    }}
                  >
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead
                        style={{
                          background: "#f8fafc",
                          position: "sticky",
                          top: 0,
                          borderBottom: "2px solid #e2e8f0",
                        }}
                      >
                        <tr>
                          {modalHeaders.map((h, cIdx) => (
                            <th key={h + cIdx} style={{
                              padding: "12px",
                              borderRight: "1px solid #e2e8f0",
                              textAlign: "center",
                              fontWeight: 600,
                              color: "#1e293b",
                              fontSize: "14px",
                            }}>
                              {h}
                              {h.toLowerCase().includes("date") && (
                                <div style={{ fontSize: "10px", color: "#94a3b8", fontWeight: 400, marginTop: "2px" }}>
                                  DD-MM-YYYY
                                </div>
                              )}
                            </th>
                          ))}
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "center",
                              fontWeight: 600,
                              color: "#1e293b",
                              fontSize: "14px",
                            }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {modalRows.map((row, rIdx) => (
                          <tr key={rIdx}>
                            {modalHeaders.map((h, cIdx) => {
                              const isPdfColumn = h === "Ledger PDF" && modalTypeKey === "ledger";
                              return (
                                <td
                                  key={h + cIdx}
                                  style={{
                                    padding: "8px",
                                    borderBottom: "1px solid #e2e8f0",
                                    borderRight: "1px solid #e2e8f0",
                                  }}
                                >
                                  {isPdfColumn ? (
                                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                      <span>{row[h] || "-"}</span>
                                      <input
                                        type="file"
                                        accept=".pdf"
                                        style={{ display: "none" }}
                                        id={`pdf-input-${rIdx}`}
                                        onChange={(e) => {
                                          const file = e.target.files[0];
                                          if (!file) return;
                                          setLedgerPdfs((prev) => ({ ...prev, [rIdx]: file }));
                                          handleCellChange(rIdx, h, file.name);
                                        }}
                                      />
                                      <button
                                        onClick={() => document.getElementById(`pdf-input-${rIdx}`).click()}
                                        style={{
                                          padding: "2px 6px",
                                          background: "#dbeafe",
                                          border: "1px solid #93c5fd",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        Upload
                                      </button>
                                      {ledgerPdfs[rIdx] && (
                                        <button
                                          onClick={() => {
                                            const copy = { ...ledgerPdfs };
                                            delete copy[rIdx];
                                            setLedgerPdfs(copy);
                                            handleCellChange(rIdx, h, "");
                                          }}
                                          style={{
                                            padding: "2px 6px",
                                            background: "#fee2e2",
                                            border: "1px solid #fecaca",
                                            borderRadius: "6px",
                                            color: "#dc2626",
                                            fontSize: "12px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          Remove
                                        </button>
                                      )}
                                    </div>
                                  ) : (
                                    <input
                                      value={String(row[h] ?? "")}
                                      onChange={(ev) => handleCellChange(rIdx, h, ev.target.value)}
                                      style={{
                                        width: "100%",
                                        padding: "6px 10px",
                                        border: "1px solid #cbd5e0",
                                        borderRadius: "6px",
                                        fontSize: "14px",
                                      }}
                                    />
                                  )}
                                </td>
                              );
                            })}
                            <td style={{ textAlign: "center" }}>
                              <button
                                onClick={() => handleDeleteRow(rIdx)}
                                style={{
                                  padding: "4px 8px",
                                  background: "#fee2e2",
                                  border: "1px solid #fecaca",
                                  borderRadius: "6px",
                                  color: "#dc2626",
                                  cursor: "pointer",
                                }}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div
                    style={{
                      display: "flex", justifyContent: "space-between", marginTop: "20px", paddingTop: "20px", borderTop: "1px solid #e2e8f0",
                    }}
                  >
                    <button
                      onClick={handleAddRow}
                      style={{
                        padding: "10px 20px",
                        background:"linear-gradient(135deg, #10b981 0%, #059669 100%)",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    >
                      + Add New Row
                    </button>

                  <button
  className="upload-action-btn primary"
  onClick={handleSaveEdits}
  disabled={isSaving}
>
  {isSaving ? (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <RefreshCw size={16} className="spin-animation" />
      Saving...
    </div>
  ) : (
    "Save Changes"
  )}
</button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <ToastContainer position="bottom-right" autoClose={3000} newestOnTop
            closeOnClick
            pauseOnHover
            draggable
            theme="colored"
            style={{
              zIndex: 20000
            }}
          />
        </main>
      </div>
    </div>
  );
};

export default UploadMenu;
